import { Box, styled, Typography } from "@mui/material";

export const TooltipBackground = styled(Box)(() => ({
	display: "flex",
	flexDirection: "column",
	flexWrap: "wrap",
	backgroundColor: "#fff",
	padding: "0",
}));

export const StatusTypography = styled(Typography)(() => ({
	textAlign: "left",
	fontSize: "11px",
	fontFamily: '"Inter", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
	color: "#918c8c",
}));

export const BoldTypography = styled("span")(() => ({
	fontWeight: "bold",
}));
